import Tippy, { TippyProps } from '@tippyjs/react/headless'
import { useState } from 'react'

// https://gist.github.com/atomiks/520f4b0c7b537202a23a3059d4eec908
export default function LazyTippy(props: TippyProps) {
  const [mounted, setMounted] = useState(false)

  const lazyPlugin = {
    fn: () => ({
      onShow: () => setMounted(true),
      onHidden: () => setMounted(false),
    }),
  }

  const computedProps = { ...props }

  computedProps.plugins = [lazyPlugin, ...(props.plugins || [])]

  if (props.render) {
    computedProps.render = (...args) => (mounted ? props.render?.(...args) : '')
  } else {
    computedProps.content = mounted ? props.content : ''
  }

  return <Tippy {...computedProps} />
}
